import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`

    #codeBody {

        > p:first-child {
            margin-bottom: 5px;
        }
    }
`